import * as yup from 'yup';
import i18n from '../i18n';

export const getPasswordRequirements = () => [
  { regex: /.{12,}/, label: i18n.t('password-requirements.min-length') },
  { regex: /[A-Z]/, label: i18n.t('password-requirements.uppercase') },
  { regex: /[a-z]/, label: i18n.t('password-requirements.lowercase') },
  { regex: /[0-9]/, label: i18n.t('password-requirements.number') },
  { regex: /[^A-Za-z0-9]/, label: i18n.t('password-requirements.special') }
];

export const getPasswordValidationSchema = () => {
  const requirements = getPasswordRequirements();

  return yup.object().shape({
    password: yup
      .string()
      .required(i18n.t('password-is-required'))
      .test('password-requirements', '', function (value) {
        if (!value) return true; // Let the required() validation handle empty values

        const failedRequirements = requirements.filter(req => !req.regex.test(value));
        if (failedRequirements.length === 0) return true;

        return this.createError({
          message: failedRequirements[0].label
        });
      })
  });
};
